<template>
  <div class="container-fluid">
    <v-row>
      <v-col lg="12" cols="12" style="margin: 0 auto">
        <v-card>
          <v-card-title class="pa-5 pb-3 primary">
            <v-icon class="pr-4" :color="'#FFFFFF'">mdi-file-document-edit</v-icon>
            <p style="color: white">Adjuntar Documentos</p>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="pt-4">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col md="6" offset-md="3">
                  <span style="text-align: center">Tipo Documento:</span>
                  <multiselect style="display: block; margin-bottom: 10px" v-model="tipoDoc.doclave"
                    deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                    select-label="Seleccione tipo de docuemento" track-by="doclave" label="dodescrip"
                    placeholder="Seleccione una opción" :options="tipoDoc.opcionesDoc" :allow-empty="false"
                    @select="removeMultiSelectError()">
                  </multiselect>
                  <span style="color: red; display: none" id="opcError"> Debe seleccionar al menos una opción </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6" offset-md="3">
                  <span style="text-align: center">Selecciona archivo</span>
                  <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                    @vdropzone-sending="sendingParameters" @vdropzone-files-added="addedFiles"></vue-dropzone>
                  <span style="color: red; display: none" id="dropzError"> Debe agregar al menos un archivo </span>
                </v-col>
              </v-row>

              <v-row justify="center" class="mb-10">
                <v-btn class="ma-2" color="#536DFE" style="color:white" @click="Guardar()" :disabled="disabledSave">
                  Guardar
                </v-btn>
                <v-btn class="ma-2" @click="Limpiar()" color="default" :disabled="disabledSave">
                  Limpiar
                </v-btn>
                <v-btn class="ma-2" color="error" @click="Cancelar()" :disabled="disabledSave">
                  Cancelar
                </v-btn>
              </v-row>
              <v-row>
                <v-col md="6" offset-md="3">
                  <div>
                    <v-alert color="blue" type="success">
                      Solo se permiten los siguientes tipos de Archivos: JPG, JPEG, PNG, PDF
                    </v-alert>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import Archivos from "@/services/Archivos/Archivos.service.js";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import vue2Dropzone from "vue2-dropzone";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  expose: ['publicMethod'],
  data: function () {
    return {
      valid: true,
      nrreporte: "",
      svindice: "",
      aiclave: "",
      disabledSave: false,
      tipoDoc: {
        opcionesDoc: [],
        doclave: "",
        dodescrip: "",
      },
      contador: 0,
      fileChunked: false,
      dropzoneOptions: {
        paramName: "file",
        maxFiles: 100,
        url: `${this.$store.state.domain.domainNameForApi}Archivos/FileUploadProcess`,
        thumbnailWidth: 200,
        acceptedFiles: "image/jpeg,image/jpg,image/png,application/pdf,",
        autoProcessQueue: false,
        chunkSize: 5242880, // 5 MB
        chunking: true,
        forceChunking: true,
        parallelUploads: 1,
        uploadMultiple: false,
        parallelChunkUploads: false,
        timeout: null,
        addRemoveLinks: true,
        dictRemoveFile: 'Eliminar',
        dictDefaultMessage: '<span class="dropzone-divided-message"> <span class="dropzone-bold-large">Seleccione sus archivos.</span><br>Arrastre aquí sus archivos.</span>',
        retryChunks: true,
        retryChunksLimit: 3,
        dictInvalidFileType: "No puedes subir archivos de este tipo",
        chunksUploaded: async function (file, done) {
          await window.FileUploadContext.successFile();
          await done();
        },
        init: function () {
          this.on("error", function (file, errorMessage) {
            if (errorMessage === "No puedes subir archivos de este tipo") {
              this.removeFile(file);
            }
          });
        },
      },
      xhrResponses: [],
      uploadStatus: true,
      filesToSend: 0,
      filesSended: 0,
      validTipo: null,
      validDocs: null,
      tipo: null,
      adjuntarArchivos: 0,
      datos: null
    };
  },
  props: [],
  computed: {
    ...mapState([
      "domain",
      "informationPage",
      "paginacion",
      "permission",
      "user",
    ]),
  },
  watch: {
    validTipo(val) {
      if (val == true) {
        document.getElementById("opcError").style.display = "none";
      } else {
        document.getElementById("opcError").style.display = "block";
      }
    },
    validDocs(val) {
      if (val == true) {
        document.getElementById("dropzError").style.display = "none";
      } else {
        document.getElementById("dropzError").style.display = "block";
      }
    },
    tipoDoc(val) {
    }
  },
  methods: {
    ...mapMutations(["changeReporteMenuOption"]),
    removeMultiSelectError() {
      document.getElementById("opcError").style.display = "none";
    },
    addedFiles() {
      document.getElementById("dropzError").style.display = "none";
    },
    async startFileUpload() {
      let tempQueue = this.$refs.myVueDropzone.getQueuedFiles();
      if (tempQueue.length == 0) {
        this.disabledSave = false;
        this.$swal({
          position: "center",
          icon: "info",
          title: "Llene los datos correctamente",
          html: "Por favor, adjunte al menos un documento.",
          showConfirmButton: true,
          allowOutsideClick: false,
          confirmButtonColor: '#536DFE',
          confirmButtonText: 'Aceptar',
        });
      } else {
        this.filesToSend = tempQueue.length;
        this.$refs.myVueDropzone.processQueue();
      }
    },
    async sendingParameters(file, xhr, formData) {
      if (this.contador > 0) {
        let index = 0;
        let jsonData = JSON.parse(this.xhrResponses[index].response);
        formData.append("data", jsonData.data);
      }
      formData.append("nrreporte", this.nrreporte);
      formData.append("svindice", this.svindice);
      formData.append("doclave", this.tipoDoc.doclave.doclave);
      formData.append("url", window.location.href);
      formData.append("filename", file.name);
      formData.append("dzId", file.upload.uuid);
      if (file.upload.chunked) {
        this.fileChunked = true;
        formData.append("chunkedFile", true);
        formData.append("chunkIndex", file.upload.chunks[this.contador].dataBlock.chunkIndex);
        formData.append("chunkSize", file.upload.chunks[this.contador].dataBlock.data.size);
      }
      this.xhrResponses.push(xhr);
      this.contador++;
    },
    async uploadAsyncSucces() {
      if (this.fileChunked == false) {
        this.xhrResponses = [];
        this.contador = 0;
        this.filesSended++;
        if (this.filesToSend == this.filesSended) {
          this.completeQueue();
        }
      }
    },
    async successFile() {
      console.log("El resp: ", this.xhrResponse);
      let jsonData = JSON.parse(this.xhrResponses[0].response);
      this.xhrResponses = [];
      this.contador = 0;
      if (this.fileChunked == true) {
        let response = await Archivos.CommitUpload(this, jsonData.data);
        this.filesSended++;
        this.fileChunked = false;
        if (response.Error == true) {
          this.uploadStatus = false;
        }
        if (this.filesToSend == this.filesSended) {
          this.completeQueue();
        }
      } else {
        this.filesSended++;
        this.fileChunked = false;
        if (this.filesToSend == this.filesSended) {
          this.completeQueue();
        }
      }
    },

    completeQueue() {
      if (this.uploadStatus == false) {
        this.disabledSave = false;
        this.$swal({
          position: "center",
          icon: "warning",
          title: "Error",
          text: "Ocurrió un error, al subir un archivo, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.",
          showConfirmButton: true,
          allowOutsideClick: false,
          confirmButtonColor: '#536DFE',
          confirmButtonText: 'Aceptar',
        });
      } else {
        this.disabledSave = true;
        this.$swal({
          position: "center",
          icon: "success",
          title: "Correcto",
          text: "El archivo se adjuntó correctamente.",
          showConfirmButton: true,
          allowOutsideClick: false,
          confirmButtonColor: '#536DFE',
          confirmButtonText: 'Aceptar',
          timer: 2500,
        }).then(async () => {
          let displayInputs = {
            nrreporte: this.nrreporte,
            svindice: this.svindice
          };
          let asistenciaurl = await MetodosGenerales.ObtenerURL(displayInputs);
          this.$router.push({ path: asistenciaurl + '/Archivos' });



        });
      }
    },
    Limpiar() {
      this.tipoDoc.doclave = "";
      this.$refs.myVueDropzone.removeAllFiles();
      document.getElementById("opcError").style.display = "none";
      document.getElementById("dropzError").style.display = "none";
    },
    async Cancelar() {
      let displayInputs = {
        nrreporte: this.nrreporte,
        svindice: this.svindice
      };
      let asistenciaurl = await MetodosGenerales.ObtenerURL(displayInputs);
      this.$router.push({ path: asistenciaurl + '/Archivos' });

    },
    Guardar() {
      this.$refs.form.validate();
      let tempQueue = this.$refs.myVueDropzone.getQueuedFiles();
      this.validTipo = this.tipoDoc.doclave == "" ? false : true;
      this.validDocs = tempQueue.length == 0 ? false : true;

      if (this.validTipo == false) { document.getElementById("opcError").style.display = "block"; }
      if (this.validDocs == false) { document.getElementById("dropzError").style.display = "block"; }

      if (this.validTipo && this.validDocs) {
        this.disabledSave = true;
        this.$swal({
          position: "center",
          title: "Guardando documentación, espere un momento...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
            this.startFileUpload();
          },
        });
      }

    },

    ObtenerCatalogoDocumentos() {
      Archivos.ObtenerCatalogoDocumentos(this, this.datos).then((data) => {
        this.tipoDoc = data;
      });
    },
    async obtenerEstadoReporte() {
      this.tipo = await MetodosGenerales.getReporteEstatus(this);
    },
  },
  async mounted() {
    this.changeReporteMenuOption('NoView');
    if (this.tipo != null) {
      this.tipo = await this.$route.params.tipoadjuntar
    } else {
      await this.obtenerEstadoReporte();
    }
    this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
    this.nrreporte = this.datos.nrreporte;
    this.svindice = this.datos.svindice;
    this.aiclave = this.datos.aiclave;
    if (this.aiclave == 26) {
      Archivos.ObtenerCatalogoDocumentos(this, this.datos);
    } else {
      Archivos.ObtenerCatalogoDocs(this, this.datos);
    }
    window.FileUploadContext = this;
    await Archivos.EstatusReporte(this, this.datos);
    if (this.adjuntarArchivos == 0) {
      this.$swal({
        position: "center",
        icon: "warning",
        title: "Error",
        text: "El reporte no cuenta con las caracteristicas necesarias para adjuntar un archivo.",
        showConfirmButton: true,
        allowOutsideClick: false,
        confirmButtonColor: '#536DFE',
        confirmButtonText: 'Aceptar',
      }).then(() => {
        this.$router.go(-1);
      });
    }
  },
};
</script>

<style>
.multiselect--active {
  z-index: 9999 !important;
}

.border-error {
  border-color: red;
}

.dz-preview {
  width: 150px;
}
</style>
